<template>
	<div>
		<div class="data">
			<div class="titulo"><h3>Documentos disponibles del período</h3></div>
			<div v-if="nodata == true" class="alert alert-primary text-center" role="alert">{{ mensaje }}</div>
			<div class="tabla" v-if="nodata == false && documentos.length > 0">
				<div class="filtro">
					<b-form-input v-model="filtro" type="search" id="filterInput" placeholder="Búsqueda"></b-form-input>
				</div>
				<div class="data">
					<b-table striped hover no-border-collapse head-variant="light" :filter="filtro" :per-page="perPage" :current-page="currentPage" :items="documentos" :fields="columnas">
					    <template #cell(opciones)="data">
							<b-dropdown size="sm" toggle-class="text-decoration-none" text="Action">
								<b-dropdown-item @click="generarFactura(data.item)">Generar Factura</b-dropdown-item>
							</b-dropdown>
						</template>
						<template #cell(monto_factura)="data">
							{{ Intl.NumberFormat('es-CL').format(data.value) }}
						</template>
					</b-table>
					<b-pagination v-model="currentPage" :total-rows="totalDoctos" :per-page="perPage"></b-pagination>
				</div>
			</div>
			<generar-factura v-if="mostrar_generar_factura" :documento="documento" :on-cerrar="onCerrar" :key="time"></generar-factura>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import $ from "jquery"
	import GenerarFactura from "./generar_factura.vue"


	export default {
		name: "UnoXUno",
		components: { GenerarFactura },
		props: {
			info: String,
		},
		data() {
			return {
				periodo: "",
				nodata: false, // Flag que indica si la respuesta del ws trajo datos o no, para mostrar el mensaje en la pantalla
				mensaje: "",
				documentos: [], // Arreglo con el total de documentos del periodo
				documento: {}, // Documento seleccionado para refacturacion
				mostrar_generar_factura: false,
				columnas: [ 
					{ key: "opciones", label: "Opciones", sortable: false }, 
					{ key: "categoria", label: "Categoría", sortable: true },
					{ key: "client_id", label: "Client Id", sortable: true },
					{ key: "client_id_madre", label: "Client Id Madre", sortable: true, class: "text-nowrap" },
					{ key: "client_name", label: "Client Name", sortable: true, class: "text-nowrap" },
					{ key: "client_tax_code", label: "Client Tax Code", sortable: true, class: "text-nowrap" },
					{ key: "grupo_economico", label: "Grupo Económico", sortable: true, class: "text-nowrap" },
					{ key: "monto_factura", label: "Monto Factura", sortable: true, class: "text-nowrap text-right" },
					{ key: "sales_rep", label: "Sales Rep", sortable: false, class: "text-nowrap" },
					{ key: "soporte", label: "Soporte", sortable: true, class: "text-nowrap" }
				],
				filtro: "",
				perPage: 10,
				currentPage: 1,
				flag: false,
				time: 0,
			}
		},
		created() {

			this.periodo = this.$periodo
			this.time = Date.now()
		},
		mounted: function() {

			// Guardamos el THIS en otra variable para poder usarla aqui. No se puede usar directamente THIS en esta parte del ciclo de vida (?????)
			const that = this

			// Escuchamos por el evento "cambio-periodo", que se genera desde el componente HEADER y lo envia a todos los componentes activos
			// Actualizamos la variable local periodo y actualizamos la data

			window.event.$on("evento-cambio-periodo", function(periodo) {

				// Leemos los datos a traves del servicio rest
				that.periodo = periodo
			})

			this.leerDatos()
		},
		computed: {

			totalDoctos() {
				return this.documentos.length
			}
		},
		methods: {

			leerDatos() {

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

                // Llamamos al WS para traer las fichas a mostrar
				var request = { 
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "F1", 
					"operacion": "F_especial", 
					"periodo": this.periodo.substr(0, 7), // cortamos el dia del periodo, para enviar solo YYYY-MM
					"nomina": this.info, 
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Chequeamos si existe la propiedad mensaje_error
					// Si existe es porque hubo un problema en la llamada o no hay datos y mostramos el mensaje
					var data = response.data
					if (data.mensaje_error !== undefined) {

						this.nodata = true
						this.mensaje = data.mensaje_error
					} else {

						this.nodata = false
						this.mensaje = ""
						this.documentos = response.data.data
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
					$(".data").removeClass("hide")

				}).catch(ex => { 

					// Si hubo un error, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
			},

			// Activa la ventana de refacturacion, pasando los datos del documento seleccionado
			generarFactura(data) {

				this.time = Date.now()
				this.documento = data
				this.mostrar_generar_factura = true
			},

			// Para cerrar la ventana de Refacturacion
			onCerrar(exito) {

				this.time = Date.now()
				this.mostrar_generar_factura = false 

				if (exito)
					this.leerDatos()
			},
		}
	}
</script>
<style scoped>

	.main {
		border-radius: 4px;
		margin-right: 5px;
		padding: 10px 15px 10px 15px;
		min-height: 800px;
		background-color: white;
		box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%);
		font-family: Arial;
	}

	.titulo {
		width: 100%;
		margin-bottom: 15px;
	}

	.tabla {
		width: 100%;
	}

	.filtro {
		width: 250px;
		padding-bottom: 10px;
	}

	.data {
		overflow: auto;
	}

</style>
